import { CommonModule, DatePipe, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import {
  PoButtonModule,
  PoContainerModule,
  PoFieldModule,
  PoModalModule,
  PoProgressModule,
  PoTooltipModule,
} from '@po-ui/ng-components';
import { AlertDisplayComponent, AtsUiLibModule, GroupByPipe, LanguageLevelPipe } from 'ats-ui-lib';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { QualificationComponent } from './qualification/qualification.component';
import { DurationMomentPipe } from './timeline/pipes/duration-moment.pipe';
import { SearchFieldComponent } from './search-field/search-field/search-field.component';
import { ButtonUploadComponent } from './button-upload/button-upload/button-upload.component';
import { FileSizePipe } from './button-upload/file-size.pipe';
import { ButtonUploadResumeComponent } from './button-upload-resume/button-upload-resume.component';
import { QualificationLevelSearchPipe } from './qualification/qualification-level-search.pipe';
import { MoreLessTextContainerComponent } from './more-less-text-container/more-less-text-container.component';
import { ColorCodePipe } from './pipes/color-code/color-code-pipe';
import { HowFindJobOpportunityEnumPipe } from './pipes/enum-pipes/format-how-find-job-opportunity/format-how-find-job-opportunity.pipe';
import { ProfessionalPurposePipe } from './pipes/enum-pipes/professional-purpose/professional-purpose.pipe';
import { PageBackArrowDirective } from './page-back-arrow/page-back-arrow.directive';
import { SupportButtonComponent } from './support-button/components/support-button.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PasswordErrorMessagesPipe } from './pipes/password-error-messages/password-error-messages.pipe';
import { CookieService } from 'ngx-cookie-service';
import { NoStandaloneSharedModule } from '../no-standalone-shared/no-standalone-shared.module';

@NgModule({
  declarations: [
    DurationMomentPipe,
    QualificationComponent,
    SearchFieldComponent,
    ColorCodePipe,
    HowFindJobOpportunityEnumPipe,
    ProfessionalPurposePipe,
    ButtonUploadComponent,
    FileSizePipe,
    ButtonUploadResumeComponent,
    QualificationLevelSearchPipe,
    MoreLessTextContainerComponent,
    PageBackArrowDirective,
    SupportButtonComponent,
    PasswordErrorMessagesPipe,
  ],
  // this module should be kept "small". Don't add big imports here, like imports to big third-party modules. Import to angular modules
  // are okay. Check periodically the size of all the modules of the application and if this module is increasing the size of the bundle
  // too much. If that's the case refactor parts of this module to separate modules.
  imports: [
    CommonModule,
    PoButtonModule,
    PoContainerModule,
    AtsUiLibModule,
    TranslateModule.forChild({ extend: true }),
    FormsModule,
    PoProgressModule,
    PoFieldModule,
    ReactiveFormsModule,
    PoTooltipModule,
    PoModalModule,
    MatCheckboxModule,
    MatTooltipModule,
    NgOptimizedImage,
    LanguageLevelPipe,
    GroupByPipe,
    NoStandaloneSharedModule,
  ],
  exports: [
    DurationMomentPipe,
    ColorCodePipe,
    QualificationComponent,
    SearchFieldComponent,
    QualificationLevelSearchPipe,
    HowFindJobOpportunityEnumPipe,
    ProfessionalPurposePipe,
    ButtonUploadComponent,
    PoProgressModule,
    ButtonUploadResumeComponent,
    PageBackArrowDirective,
    SupportButtonComponent,
    AlertDisplayComponent,
    MoreLessTextContainerComponent,
    PasswordErrorMessagesPipe,
    LanguageLevelPipe,
    GroupByPipe,
    NoStandaloneSharedModule,
  ],
  providers: [DatePipe, QualificationLevelSearchPipe, CookieService],
})
export class SharedModule {}
